import Vuex, { Store } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { Md5 } from 'ts-md5/dist/md5';

import { order } from '@/store/order/OrderStore';
import tempAmount from '@/store/tempAmount';
import userProfileProgress from '@/store/userProfileProgress';
import userAutarkyStatus from '@/store/userAutarkyStatus';
import userCreditStatus from '@/store/userCreditStatus';
import { financeStorageKeyPrefix } from '@/constant';
import type { LoanRightStateType } from '@/views_v2/apply-product/types';
// import { ubtSendError } from '@/shared/utils/ubt';
import base from './base';
import type RootStateType from './types';
import { UPDATE_STATE_TYPE } from './generate-mutations';

const store: Store<RootStateType> = new Vuex.Store({
  plugins: [],
  modules: {
    order,
    base,
    tempAmount,
    userProfileProgress,
    userAutarkyStatus,
    userCreditStatus,
  },
});

// 更新指定模块的指定属性集合
export const updateModuleState = (
  moduleName: string,
  payload: Dictionary,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => store.dispatch(`${moduleName}/${UPDATE_STATE_TYPE}`, payload);

// 在登录成功之后，启用持久化存储并按照登录用户进行数据隔离
export const usePersistedState = (): void => {
  // 用于存储持久化缓存key值
  const keyOfPersistedKey = `${financeStorageKeyPrefix}_PersistedKey`;
  // 获取旧的token对应的key值
  const lastPersistKey = localStorage.getItem(keyOfPersistedKey);

  const currentPersistKey = `${financeStorageKeyPrefix}_${Md5.hashStr(store.state.base.token)}`;

  if (lastPersistKey && lastPersistKey !== currentPersistKey) {
    // 考虑到切换用户的情况，暂不恢复除token之外的其它持久化缓存数据到store里面
    // 移除旧的缓存信息
    localStorage.removeItem(lastPersistKey);
  }
  // 更新持久化缓存key值
  localStorage.setItem(keyOfPersistedKey, currentPersistKey);

  createPersistedState({
    key: currentPersistKey,
    paths: [
      'base.token',
      'home',
      'baseInfoIdentity',
    ],
  })(store);

  // TODO:临时性解决方案，提现环节right的数据另外存储，防止影响其他流程
  const rightKey = (store.state.base.originUserInfo
    && store.state.base.originUserInfo.mobile) || store.state.base.userId;
  const rightPersistedKey = `${financeStorageKeyPrefix}_${Md5.hashStr(rightKey)}`;
  const rightPersistedKeyLast = `${financeStorageKeyPrefix}_${Md5.hashStr(rightPersistedKey)}`;

  /** TODO: 清楚缓存值，以解决线上undefined问题，后续如果上线很长一段时间，可以删除该代码 */
  const rightPersistedValue = localStorage.getItem(rightPersistedKeyLast);
  if (rightPersistedValue) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const rightValueFormat: {loanRight: LoanRightStateType} = JSON.parse(rightPersistedValue);
      // 如果存在缓存 & 缓存的值为undefined，手动showSpeed赋为false兜底，防止showspeed为undefined页面不刷新
      if (rightValueFormat
      && rightValueFormat.loanRight
      && rightValueFormat.loanRight.showSpeed === undefined) {
        const loanRight = {
          ...rightValueFormat.loanRight,
          showSpeed: false,
        };
        localStorage.setItem(rightPersistedKeyLast,
          JSON.stringify({ loanRight }));
        // 此处的监控主要是为后续删除代码作参考依据
        // setTimeout(() => {
        //   ubtSendError('showSpeed in loanRightData match undefined');
        // }, 0);
      }
    } catch {
      // dosomething
      // ubtSendError('loanRightData parse error');
    }
  }
  /** 清楚缓存值，后续如果上线很长一段时间，可以删除该代码 */
};
// 获取用户登录token信息，适配H5和客户端以及小程序
// H5因为在登录完成之前无法使用持久化存储信息，依赖usePersistedState的执行时机
// 所以需要从localstore里获取
export const getAuthToken = (): string => store.state.base.token;

export default store;
